import React from "react";
import "./ToggleSwitch.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ToggleSwitch2 = ({
  meetingId,
  isActive,
  handleToggle,
  tooltipTextActive = "Click to Stop Nuture",
  tooltipTextInactive = "Click to Start Nurture",
  showTooltip = true,
}) => {
  const tooltip = (
    <Tooltip className="custom-tooltip">
      {isActive ? tooltipTextActive : tooltipTextInactive}
    </Tooltip>
  );

  const content = (
    <div className="toggle-switch" key={`toggle_switch_id_${meetingId}`}>
      <label className="switch">
        <input type="checkbox" checked={isActive} readOnly />
        <span className="slider round" onClick={handleToggle}></span>
      </label>
    </div>
  );

  return showTooltip ? (
    <OverlayTrigger placement="top" overlay={tooltip}>
      {content}
    </OverlayTrigger>
  ) : (
    content
  );
};

export default ToggleSwitch2;
